export const placement = [
    'top',
    'topStart',
    'topEnd',
    'left',
    'leftStart',
    'leftEnd',
    'bottom',
    'bottomStart',
    'bottomEnd',
    'right',
    'rightStart',
    'rightEnd',
];
